<template>
  <div class="station-detail">
    <div>{{statileInfo.name}}</div>
    <div>
      <div v-html="statileInfo.contents"></div>
    </div>
    <div><img :src="FILE_BASE_URL+statileInfo.image" class="img1" /></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      statileInfo:{},
      FILE_BASE_URL:this.$API.FILE_BASE_URL
    };
  },
  mounted() {
    this.statileInfo = JSON.parse(localStorage.getItem("statileInfo")) 
    this.queryVolunteerById(this.statileInfo.id)
  },
  methods: {
    //点击次数统计
    queryVolunteerById(id) {
      let params = {
        id: id,
      };
      this.$API.queryVolunteerById(params);
    },
  }
};
</script>
<style lang="scss" scoped>
.img1 {
  width: 854px;
  height: 536px;
}
.station-detail {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; 
  padding-bottom: 60px;
  > div:nth-child(1) {
    font-size: 26px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
    font-weight: 700;
    color: #333333;
    margin-top: 40px;
  }
  > div:nth-child(2) {
    font-size: 18px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
    font-weight: 400;
    color: #333333;
      margin-top: 52px;

  }
  >div:nth-child(3){
      margin-top: 40px;
  }
}
</style>